import type { LandingHeroImagePublic, PublicProductSummary } from '@repo/api-contracts';
import type { HeroSlideItem } from './hero-slide-item';
import { resolveHeroCopy } from './resolve-hero-copy';

/** 배너가 없을 때 추천 목록에서 싣는 최대 장 수. */
const MAX_FALLBACK_SLIDES = 6;

/**
 * 히어로 슬라이드 목록을 만든다.
 * 배너가 있으면 배너 순서대로 한 장씩 — 사진은 배너 사진, 문구는 필드마다 배너 문구가 먼저이고
 * 비었으면 배너에 연결한 상품 정보(둘 다 없으면 사진만).
 * 배너가 없을 때만 추천 목록 앞에서부터 최대 6장을 사진 없이(흑연 판) 상품 문구로 싣는다.
 * 상품 대표사진·썸네일은 배너 배경으로 쓰지 않는다.
 */
export const buildHeroSlides = (
  banners: readonly LandingHeroImagePublic[],
  products: readonly PublicProductSummary[],
): readonly HeroSlideItem[] =>
  banners.length > 0
    ? banners.map((banner) => ({
        id: banner.id,
        imageUrl: banner.imageUrl,
        copy: resolveHeroCopy(banner.copy, banner.product),
      }))
    : products.slice(0, MAX_FALLBACK_SLIDES).map((product) => ({
        id: product.id,
        imageUrl: null,
        copy: resolveHeroCopy(null, product),
      }));
